var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAustraliainline = function SvgAustraliainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.203 0h30v30h-30V0Z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.418 21.598 2.379.902.785-2.426.78 2.426 2.384-.902-1.412 2.127 2.191 1.3-2.537.217.352 2.526-1.758-1.846-1.758 1.846.352-2.52-2.543-.223 2.197-1.3m19.043 4.19-1.113.093.158 1.101-.762-.802-.761.802.134-1.101-1.101-.094.955-.562-.615-.926 1.037.392.34-1.054.334 1.054 1.043-.392-.61.926m.95-15.844-1.102.094.152 1.101-.762-.803-.761.803.14-1.101-1.101-.094.955-.563-.615-.925 1.037.392.34-1.055.334 1.055 1.043-.393-.61.926m-5.203 7.23-1.102.095.153 1.095-.762-.802-.762.802.147-1.095-1.102-.094.955-.569-.615-.92 1.037.393.34-1.055.334 1.055 1.037-.392-.61.92m12.563-1.073-1.101.094.152 1.096-.762-.803-.761.803.146-1.096-1.101-.094.955-.568-.616-.92 1.037.393.34-1.055.34 1.055 1.031-.393-.609.92M24.611 20.8l-.603.375.17-.692-.545-.457.703-.052.275-.657.258.662.71.06-.54.45.17.692",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.203 0h15v15h-15V0Z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.203 0v1.875L9.637 7.5l5.566 5.479V15H13.24L7.645 9.492 2.195 15H.203v-1.992l5.45-5.479-5.45-5.361V0H2.02l5.625 5.508L13.094 0h2.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.594 9.492.322.996L1.434 15H.204v-.088l5.39-5.42Zm3.633-.351 1.582.234 4.394 4.307V15L9.227 9.14ZM15.203 0 9.578 5.742l-.117-1.289L13.855 0h1.348Zm-15 .03 5.654 5.536-1.728-.234L.203 1.436V.029Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36 0v15h4.687V0H5.359ZM.202 5.156v4.688h15V5.156h-15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.203 6.094v2.812h15V6.094h-15ZM6.297 0v15h2.812V0H6.297Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.203,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#fff"
  })))));
};
export default SvgAustraliainline;